<template>
  <tr>
    <td>
      <!-- <input
        type="radio"
        :checked="selectedJd && selectedJd._id === jd._id"
        @change="matchJobseekers(jd)"
      /> -->
    </td>
    <td @click="showJDModal">{{ createdDate }}</td>

    <td @click="matchJobseekers(jd)" v-html="highlightedJobTitle"></td>

    <!-- <JDDetailModal
      :jd="jd"
      :highlightedJobTitle="highlightedJobTitle"
      v-if="isModalOpen"
      :isOpen="true"
      @closeJdModal="closeJdModal"
    /> -->
  </tr>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import JDDetailModal from './JDDetailModal.vue';
export default {
  name: 'JDRow',
  props: ['jd', 'selectedJd'],
  components: { JDDetailModal },
  data() {
    return {
      jdData: this.jd,
      isModalOpen: false,
      // selectedJd: null,
    };
  },
  computed: {
    ...mapGetters({
      selectedDateRange: 'jd/getSelectedDateRange',
      fromAgeModel: 'jd/getFromAgeModel',
      toAgeModel: 'jd/getToAgeModel',
      fromIncomeModel: 'jd/getFromIncomeModel',
      toIncomeModel: 'jd/getToIncomeModel',
      statusModel: 'jd/getStatusModel',
      englishSkillModel: 'jd/getEnglishSkillModel',
      childJobModel: 'jd/getChildJobModel',
      mainJobModel: 'jd/getMainJobModel',
    }),
    createdDate() {
      if (this.jd.updated_date) {
        return moment(this.jd.updated_date).format('YYYY/MM/DD');
      } else {
        return moment(this.jd.created_date).format('YYYY/MM/DD');
      }
    },
    updatedDate() {
      let date = this.jd.updated_date;
      if (!date) {
        return '';
      } else {
        return moment(this.jd.updated_date).format('YYYY/MM/DD');
      }
    },
    highlightedJobTitle() {
      if (!this.jdData.highlights || !this.jdData.highlights.length) {
        return this.jdData.job_title;
      }

      const highlight = this.jdData.highlights.find(
        (h) => h.path === 'job_title'
      );
      if (!highlight || !highlight.texts) {
        return this.jdData.job_title;
      }

      const hits = highlight.texts
        .filter((text) => text.type === 'hit')
        .map((text) => text.value)
        .sort((a, b) => b.length - a.length);

      return this.highlightHits(
        this.highlightFullWidthSpaces(this.jdData.job_title, hits),
        hits
      );
    },
  },
  methods: {
    ...mapMutations({
      setSelectedJd: 'jd/setSelectedJd',
    }),
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    highlightFullWidthSpaces(text, hits) {
      // Create patterns for all possible hit combinations with full-width space
      const patterns = hits.flatMap((hit1, index) =>
        hits.slice(index + 1).map((hit2) => ({
          pattern: new RegExp(
            `(${this.escapeRegExp(hit1)}　${this.escapeRegExp(
              hit2
            )})|(${this.escapeRegExp(hit2)}　${this.escapeRegExp(hit1)})`,
            'g'
          ),
          replacement: (_, g1, g2) => {
            const match = g1 || g2;
            const [first, second] = match.split('　');
            return `${first}<span class="highlight-hit">　</span>${second}`;
          },
        }))
      );

      // Apply all patterns at once
      return patterns.reduce(
        (text, { pattern, replacement }) => text.replace(pattern, replacement),
        text
      );
    },

    highlightHits(text, hits) {
      const highlightedPositions = new Set();

      return hits.reduce((text, hit) => {
        const pattern = new RegExp(this.escapeRegExp(hit), 'g');
        return text.replace(pattern, (match, offset) => {
          const positions = Array.from(
            { length: match.length },
            (_, i) => offset + i
          );

          if (positions.every((pos) => !highlightedPositions.has(pos))) {
            positions.forEach((pos) => highlightedPositions.add(pos));
            return `<span class="highlight-hit">${match}</span>`;
          }
          return match;
        });
      }, text);
    },
    handleDateRangeChange(selectedDateRange) {
      let fromDate = null;

      switch (selectedDateRange) {
        case '1week':
          fromDate = moment()
            .subtract(1, 'weeks')
            .format('YYYY-MM-DD');
          break;
        case '2weeks':
          fromDate = moment()
            .subtract(2, 'weeks')
            .format('YYYY-MM-DD');
          break;
        case '1month':
          fromDate = moment()
            .subtract(1, 'months')
            .format('YYYY-MM-DD');
          break;
        case '2months':
          fromDate = moment()
            .subtract(2, 'months')
            .format('YYYY-MM-DD');
          break;
        default:
          fromDate = null;
      }
      return fromDate;
    },
    getQueryParams() {
      const filters = {
        created_date: this.handleDateRangeChange(this.selectedDateRange),
        age_from: this.fromAgeModel,
        age_to: this.toAgeModel,
        last_year_income_from: this.fromIncomeModel,
        last_year_income_to: this.toIncomeModel,
        status: this.statusModel.join(','),
        english_skills: this.englishSkillModel.join(','),
        latest_occupation_sub_title: this.childJobModel.join(','),
        latest_occupation_main_title: this.mainJobModel.join(','),
      };
      console.log(filters);
      return filters;
    },
    matchJobseekers(jd) {
      this.$emit('handleSelectedJd', { jd });
    },
    navigateToRoute(type) {
      const route = {
        path:
          type === 'list'
            ? `/job-matching-list/${this.jd._id}`
            : `/job-matching/${this.jd._id}`,
        query: this.getQueryParams(),
      };
      const routeData = this.$router.resolve(route);
      window.open(routeData.href, '_blank');
    },
    formatHighlightText(texts) {
      return texts
        .map((text) => {
          if (text.type === 'hit') {
            return `<span class="highlight-hit">${text.value}</span>`;
          }
          return text.value;
        })
        .join('');
    },
    showJDModal() {
      this.isModalOpen = true;
    },
    closeJdModal() {
      this.isModalOpen = false;
    },
  },
  watch: {
    jd: {
      handler(newJd) {
        const fieldsToUpdate = {
          highlights: newJd.highlights,
          job_title: newJd.job_title,
        };
        Object.assign(this.jdData, fieldsToUpdate);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.btn {
  width: 80px !important;
  min-width: 50px !important;
}
.button-group {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}
.match-button {
  background: #006c6b;
  padding: 5px 10px !important;
}
.match-button:hover {
  background: #006c6b;
}

.btn-success {
  border-radius: 5px !important;
}

.btn-success:focus {
  background: #006c6b !important;
  border-color: #006c6b !important;
  box-shadow: none !important;
}

td {
  padding: 5px !important;
  text-align: left !important;
  border-bottom: 1px solid black !important;
  cursor: pointer;
}
td {
  height: 50px;
}
.highlight-hit {
  background-color: yellow;
}
</style>
